import { createSlice } from '@reduxjs/toolkit';
import {
  uploadDoctorFile
} from './importPersonsThunk';

const initialState = {
  loading: false,
  success: false,
  error: null,
};

const uploadDoctorSlice = createSlice({
  name: 'upload',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadDoctorFile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadDoctorFile.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(uploadDoctorFile.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});


export default uploadDoctorSlice.reducer;